import EditableLabel from '../../../../../../components/EditableLabel/EditableLabel'
import React, { useContext } from 'react'
import { BuilderContext } from '../../../store/store.Builder'
import EditableDescription from '../../../../../../components/EditableDescription/EditableDescription'
import styles from './TextField.module.css'

const TextField = ({ field }) => {
  return <div></div>
}

export default TextField
